/* MainCondition.ts */

export enum MainConditionType {
  OTHER = "Other",
  C83_3 = "C83.1 Diffuse large B-cell lymphoma",
  C91_1 = "C91.1 B-cell chronic lymphocytic leukemia",
}
